// A flamingo, modelled facing +X: a tall pink body on stilt legs, a long curving
// neck and a down-bent black-tipped beak. Ported 1:1 from age-of-mcp's classic
// flamingo.ts, restoring its leg loop + body/neck/head composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const z of [0.016, -0.016]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.0035, 0.003, 0.16, 4),
      color: "#e8889a", position: [0, 0.08, z] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.036, 0), color: "#f4a0b4",
      position: [0, 0.19, 0], scale: [1.4, 1, 0.85] },               // body
    // Curving neck — three segments arcing up then forward-down.
    { geometry: new THREE.CylinderGeometry(0.006, 0.009, 0.07, 5), color: "#f4a8ba",
      position: [0.025, 0.25, 0], rotation: [0, 0, -0.3] },
    { geometry: new THREE.CylinderGeometry(0.005, 0.006, 0.06, 5), color: "#f4a8ba",
      position: [0.045, 0.3, 0], rotation: [0, 0, 0.3] },
    { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.04, 5), color: "#f4a8ba",
      position: [0.06, 0.33, 0], rotation: [0, 0, 1.1] },
    { geometry: new THREE.IcosahedronGeometry(0.013, 0), color: "#f8b0c2",
      position: [0.082, 0.325, 0] },                                 // head
    { geometry: new THREE.ConeGeometry(0.006, 0.026, 4), color: "#1a1a1a",
      position: [0.098, 0.31, 0], rotation: [0, 0, -2.2] },          // bent beak
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#f06f8a",
      position: [-0.03, 0.195, 0], scale: [1, 1.2, 1] },             // wing blush
  );
  return parts;
}

export const flamingo = defineModel({
  id: "flamingo",
  batchId: "standard",
  name: "Flamingo",
  tags: ["creature","flamingo","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly flamingo.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
